import { RefObject, useEffect } from 'react'

export interface UseClickOutside {
  ref: RefObject<HTMLElement | null> | RefObject<HTMLElement | null>[]
  callback: () => void
  breakpoint?: number
  ignoredElement?: RefObject<HTMLElement | null>
}

export const useClickOutside = ({
  ref,
  callback,
  breakpoint,
  ignoredElement
}: UseClickOutside) => {
  useEffect(() => {
    const handleOutSideClick = (e: PointerEvent) => {
      const isRefArray = Array.isArray(ref)
      const isClickOutsideElements = isRefArray
        ? !ref.some(
            ref => ref?.current && ref.current.contains(e.target as Node)
          )
        : ref?.current && !ref.current.contains(e.target as Node)

      const isClickOnIgnoredElement = ignoredElement?.current?.contains(
        e.target as Node
      )

      if (isClickOutsideElements && !isClickOnIgnoredElement) {
        callback()
      }
    }

    if ((breakpoint && window.innerWidth >= breakpoint) || !breakpoint) {
      document.addEventListener('pointerdown', handleOutSideClick)
    }

    return () => {
      document.removeEventListener('pointerdown', handleOutSideClick)
    }
  }, [ref, callback, breakpoint, ignoredElement])
}
